import PropTypes from 'prop-types';
import LegacyProposalForm from './legacy-proposal-form';
import DynamicProposalForm from '../form/proposal-form';
import { useFeatureFlag } from 'entities/helpers/use-feature-flag';

const ProposalForm = (props) => {
  // NOTE: LaunchDarkly Flags DO NOT WORK if this component is a child of the OLD Modal component (i.e. the one inside "src/scripts/components/modal")
  // This is because the old modals are rendered inside of the "MetaContext" and, therefore, are not descendents of our LaunchDarklyProvider.
  const { flagEnabled: hasConditionalFields } = useFeatureFlag('conditionalFields');

  if (hasConditionalFields) {
    return <DynamicProposalForm {...props} />;
  } else {
    return <LegacyProposalForm {...props} />;
  }
};

ProposalForm.propTypes = {
  proposal: PropTypes.object,
  primaryContactId: PropTypes.number,
  closeModal: PropTypes.func,
  setProposal: PropTypes.func,
  afterCreate: PropTypes.func,
};

export default ProposalForm;
